import * as SlotFamilyType from '../constants/SlotFamilyType';

export default function slotIdProvider(slotType, slotFamily, outcome) {
    const id = outcome.get('id');
    const conditionOne = outcome.get('condition');
    const playerId = outcome.get('playerId');

    switch (slotFamily) {
        case SlotFamilyType.TENNIS_GAME:
            return `${slotType}_${conditionOne}`;

        case SlotFamilyType.SINGLE_OUTCOME:
        case SlotFamilyType.WIDE_SINGLE_OUTCOME:
            return `${slotType}_${id}`;

        case SlotFamilyType.TOTAL:
            if (playerId !== undefined && playerId !== null) {
                return `${slotType}_${playerId}_${conditionOne}`;
            }
            return slotType;
    }

    return slotType;
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/providers/SlotIdProvider.js